// src/pages/treatments/PediatricDentistry.jsx
import { Link } from 'react-router-dom';
import PDhero from '../../Assets/images/PDT1.png'
import PD from '../../Assets/images/PD.jpg'
const PediatricDentistry = () => {
  return (
    <main className="pt-20 md:pt-24 min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative h-80 md:h-[500px] flex items-center justify-center bg-blue-50">
        <div className="absolute inset-0">
          <img
            src={PDhero}
            alt="Pediatric Dentistry"
            className="w-full h-full object-cover brightness-75"
          />
        </div>
        <div className="relative z-10 text-center text-white px-6">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 tracking-tight">
            Pediatric Dentistry
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto font-light">
            Caring for the baby tooth is right for the future!
          </p>
        </div>
      </section>

      {/* Breadcrumb */}
      {/* <div className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-6 py-4 flex flex-wrap items-center text-sm text-gray-600">
          <Link to="/" className="hover:text-blue-600 transition">Home</Link>
          <span className="mx-2">›</span>
          <Link to="/treatments" className="hover:text-blue-600 transition">Treatments</Link>
          <span className="mx-2">›</span>
          <span className="text-blue-600 font-medium">Pediatric Dentistry</span>
        </div>
      </div> */}

      {/* Main Content – Flex Layout */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
            {/* Image Section */}
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src={PD}
                alt="Pediatric Dentistry Procedure"
                className="w-full max-w-md rounded-2xl shadow-xl object-cover"
              />
            </div>

            {/* Text Content */}
            <div className="w-full lg:w-1/2 flex flex-col">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Expert Pediatric Dentistry in Hyderabad
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Pediatric dentistry in Hyderabad concerns the oral health of infants through their teen years. Since baby teeth are the foundation for the permanent ones, the dentists who perform this procedure are experts in their field. Children lose their first teeth around the age of 6-7. Without proper dental care, they might face possible oral decay and disease-causing infections that might lead to complications and lifetime pain.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-8">
                Baby teeth set the foundation for permanent healthy teeth. It is important to keep the teeth clean and teach children to brush and floss. Dental visits have to be early and frequent to monitor the development of the teeth. Below are some of the early dental problems that a child may face.
              </p>

              {/* Benefits / Features – Flex wrap */}
              <div className="flex flex-wrap gap-6 mb-10">
                <div className="flex-1 min-w-[200px] p-4 bg-blue-50 rounded-lg shadow-md">
                  <h4 className="font-bold text-lg mb-2">Periodontal Disease</h4>
                  <p className="text-gray-600">Gum diseases affecting children's oral health.</p>
                </div>
                <div className="flex-1 min-w-[200px] p-4 bg-blue-50 rounded-lg shadow-md">
                  <h4 className="font-bold text-lg mb-2">Laser Dentistry</h4>
                  <p className="text-gray-600">Painless treatments for kids.</p>
                </div>
                <div className="flex-1 min-w-[200px] p-4 bg-blue-50 rounded-lg shadow-md">
                  <h4 className="font-bold text-lg mb-2">Crowns & Bridges</h4>
                  <p className="text-gray-600">Restorative options for damaged teeth.</p>
                </div>
                <div className="flex-1 min-w-[200px] p-4 bg-blue-50 rounded-lg shadow-md">
                  <h4 className="font-bold text-lg mb-2">Endodontic</h4>
                  <p className="text-gray-600">Root canal for infected teeth.</p>
                </div>
                <div className="flex-1 min-w-[200px] p-4 bg-blue-50 rounded-lg shadow-md">
                  <h4 className="font-bold text-lg mb-2">Full Mouth Rehabilitation</h4>
                  <p className="text-gray-600">Comprehensive care for oral health.</p>
                </div>
                <div className="flex-1 min-w-[200px] p-4 bg-blue-50 rounded-lg shadow-md">
                  <h4 className="font-bold text-lg mb-2">Dentures</h4>
                  <p className="text-gray-600">Replacement for missing teeth.</p>
                </div>
              </div>

              {/* CTA */}
              <div className="flex justify-start">
                <Link to="/book-appointment" className="bg-blue-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-blue-700 transition">
                  Book Appointment
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default PediatricDentistry;